<template>
  <div class="add-content-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="550px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="130px">
        <el-form-item label="达成条件:" prop="finishCondition">
          <el-input v-model="params.finishCondition" type="number" size="small" placeholder="请输入达成条件(连续签到多少天/活跃值)" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="奖品类型:" prop="type">
          <el-select v-model="params.type" size="small" placeholder="请选择奖品类型" style="width:300px">
            <el-option v-for="item in types" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖品列表:" prop="prices">
          <el-select v-model="params.prizes" size="small" placeholder="请选择奖品列表" style="width:300px" multiple filterable>
            <el-option v-for="item in prizeBox" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务标题:" prop="title">
          <el-input v-model="params.title" type="text" size="small" placeholder="请输入任务标题" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="任务描述:" prop="desc">
          <el-input v-model="params.desc" type="textarea" size="small" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入任务描述" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="状态:" prop="status">
          <el-select v-model="params.status" size="small" placeholder="请选择状态" style="width:300px">
            <el-option v-for="item in statusType" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  props: {
    prizeBox: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      title: "",
      flag: false,
      id: "",
      dialogVisible: false,
      statusType: [
        {
          label: "启用",
          value: true,
        },
        {
          label: "禁用",
          value: false,
        },
      ],
      types: [
        {
          label: "签到福利",
          value: 1,
        },
        {
          label: "宝箱福利",
          value: 2,
        },
        {
          label: "消费回馈(站群)",
          value: 3,
        },
        {
          label: "消费回馈(棋牌)",
          value: 4,
        },
      ],
      prices: [],
      rules: {
        finishCondition: [
          {
            required: true,
            message: "请输入达成条件(连续签到多少天/活跃值)",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择配置类型", trigger: "change" },
        ],
        prizes: [
          { required: true, message: "请选择奖品列表", trigger: "change" },
        ],
      },
      params: {
        finishCondition: "",
        type: "",
        title: undefined,
        desc: undefined,
        prizes: [],
        status: false,
      },
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增配置") {
            this.addContent();
            return;
          }
          if (this.title === "编辑配置") {
            this.editContent();
            return;
          }
        }
      });
    },
    // 新增内容
    addContent() {
      let params = Object.assign({}, this.params, {
        finishCondition: Number(this.params.finishCondition),
      });
      API.addSigninConfig(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$emit("handlerContent");
          } else {
            this.$message.error(res.msg || "新增失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 修改内容
    editContent() {
      let params = Object.assign({}, this.params, {
        finishCondition: Number(this.params.finishCondition),
      });
      API.editSigninConfig(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$emit("handlerContent");
          } else {
            this.$message.error(res.msg || "修改失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        finishCondition: "",
        type: "",
        prizes: "",
        desc: undefined,
        title: undefined,
        status: false,
      };
    },
    open(type, data) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.params = Object.assign({}, data);
        this.title = "编辑配置";
      } else {
        this.title = "新增配置";
      }
    },
  },
};
</script>
<style scoped>
.el-input {
  width: 220px;
}
</style>